import axios from "axios";
import { HfdBlogActions } from "./blogAction";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";

const getAdminURL = (state) => {
  return state.environnment.environmentLists.adminBaseURL;
};

export const createBlogAsync = (
  detail,
  setSubmitting,
  resetForm,
  redirectBack
) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(HfdBlogActions.createBlogStart());
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/hfdblog/create`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: detail,
      });
      if (data.code === 200 && data.status) {
        dispatch(HfdBlogActions.createBlogSuccess(data.data));
        setSubmitting(false);
        // resetForm();
        redirectBack();
        return dispatch(showSuccessSnackbar("success", data.message, 3000));
      }
      dispatch(HfdBlogActions.createBlogError());
      dispatch(showSuccessSnackbar("error", data.message, 3000));
      setSubmitting(false);
    } catch (error) {
      dispatch(HfdBlogActions.createBlogError());
      setSubmitting(false);
      // resetForm();
      dispatch(
        showSuccessSnackbar("error", "Error while fetching Data.", 3000)
      );
    }
  };
};

export const getAllBlogAsync = (searchBy, searchText, status) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(HfdBlogActions.getAllBlog());
      let { skip, limit } = getState().blog;
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/hfdblog/getAll?skip=${skip}&limit=${limit}&column=${searchBy}&search=${searchText}&status=${status}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(HfdBlogActions.getAllBlogSuccess(data.data));
      }
      dispatch(HfdBlogActions.getAllBlogError());
      dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      console.log("Error: ", error);
      dispatch(HfdBlogActions.getAllBlogError());
      dispatch(
        showSuccessSnackbar("error", "Error while fetching Data.", 3000)
      );
    }
  };
};

export const getBlogDetailAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(HfdBlogActions.getBlogDetail());
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/hfdblog/getDetail/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(HfdBlogActions.getBlogDetailSuccess(data.data));
      }
      dispatch(HfdBlogActions.getBlogDetailError());
      dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      dispatch(HfdBlogActions.getBlogDetailError());
      dispatch(
        showSuccessSnackbar("error", "Error while fetching Data.", 3000)
      );
    }
  };
};

export const updateBlogAsync = (
  values,
  setSubmitting,
  resetForm,
  redirectBack
) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      //let { _id } = getState().auth.user;
      let { selectedBlog } = getState().blog;
      dispatch(HfdBlogActions.updateBlogStart());
      const { data } = await axios({
        method: "PUT",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/hfdblog/update/${selectedBlog._id}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: values,
      });

      if (data.code === 200 && data.status) {
        dispatch(HfdBlogActions.updateBlogSuccess(data.data));
        setSubmitting(false);
        resetForm();
        redirectBack();
        return dispatch(showSuccessSnackbar("success", data.message, 3000));
      }
      dispatch(HfdBlogActions.updateBlogError());
      setSubmitting(false);
      return dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      dispatch(HfdBlogActions.updateBlogError(error));
      setSubmitting(false);
      resetForm();
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const deleteBlogAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(HfdBlogActions.deleteBlogStart());
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/hfdblog/remove/${id}`,
        method: "delete",
      });
      if (data.code === 200) {
        dispatch(HfdBlogActions.deleteBlogSuccess(data.data));
        return dispatch(showSuccessSnackbar("success", data.message, 3000));
      }
      dispatch(HfdBlogActions.deleteBlogError());
      return dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      console.log("Error: ", error);
      dispatch(HfdBlogActions.deleteBlogError());
      dispatch(
        showSuccessSnackbar(
          "error",
          "Error while updating.Please try again after sometime..",
          3000
        )
      );
    }
  };
};

export const getBlogLogsAsync = (blogId) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(HfdBlogActions.getBlogLogs());
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/hfdblog/getLogs/${blogId}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(HfdBlogActions.getBlogLogsSuccess(data.data));
      }
      dispatch(HfdBlogActions.getBlogLogsError());
      dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      dispatch(HfdBlogActions.getBlogLogsError());
      dispatch(
        showSuccessSnackbar("error", "Error while fetching Data.", 3000)
      );
    }
  };
};

export const updateSelectedBlogStatusAsync = (ids, status) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      const { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/hfdblog/updateSelectedStatus`,
        method: "put",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          ids,
          status,
        },
      });
      if (data.code === 200) {
        dispatch(
          showSuccessSnackbar(
            "success",
            "Status updated successfully",
            3000,
          ),
        );
        return true;
      }
      dispatch(showSuccessSnackbar("error", data.message, 3000));
      return false;
    } catch (error) {
      console.log("Error: ", error);
      dispatch(
        showSuccessSnackbar(
          "error",
          "Error while updating status. Please try again after sometime.",
          3000,
        ),
      );
      return false;
    }
  };
};
